import { downloadFile, previewFile } from '@utils/request'
import icons from '@icons'

export const initAttachments = (context = document) => {
	context.querySelectorAll('.se-attachment-item').forEach((el) => {
		let attachmentId
		const match = el.className.match(/se-attachment-(\d+)/)
		if (match && match[1]) {
			attachmentId = match[1]
		} else {
			return
		}

		const isPreviewable = el.classList.contains('se-attachment-previewable')

		const previewButtonHtml = `<button type='button' class='se-attachment-preview-button' data-action='preview-attachment' title='미리보기'>${icons.preview}</button>`
		const downloadButtonHtml = `<button type='button' class='se-attachment-download-button' data-action='download-attachment' title='다운로드'>${icons.download_file}</button>`
		const buttonsHtml = `${isPreviewable ? previewButtonHtml : ''}${downloadButtonHtml}`

		el.insertAdjacentHTML('beforeend', buttonsHtml)

		el.addEventListener('click', async (ev) => {
			const action = ev.target.getAttribute('data-action')
			if (!action) return

			if (action === 'download-attachment') {
				await downloadFile(`/clips/${attachmentId}/download`)
			} else if (action === 'preview-attachment') {
				await previewFile(`/clips/${attachmentId}/preview`)
			}
		})
	})
}

export const initCollapsibleElements = () => {
	document.querySelectorAll('.collapsible').forEach((el) => {
		el.addEventListener('click', (ev) => {
			ev.preventDefault()

			el.nextElementSibling.classList.toggle('hidden')
			el.classList.toggle('active')
		})
	})
}

export const initAutoClosableElements = () => {
	document.addEventListener('click', (ev) => {
		document.querySelectorAll('.auto-closable').forEach((el) => {
			const acx = document.querySelector(el.getAttribute('data-ac-x'))

			if (el === ev.target) return
			if (!el.contains(ev.target) || (acx && !acx.contains(ev.target))) el.classList.add('hidden')
			//if (!el.contains(ev.target)) el.classList.add('hidden')
		})
	})
}

export const initClickTriggers = (clickHandlers) => {
	document.querySelectorAll('.click-trigger').forEach((el) => {
		el.addEventListener('click', (ev) => {
			const action = ev.target.getAttribute('data-click')
			if (action) clickHandlers[action](ev)
		})
	})
}

export const initMobileNavBehavior = () => {
	const openMenuButton = document.querySelector('.open-menu-button')
	if (openMenuButton) {
		openMenuButton.addEventListener('click', (ev) => {
			const menubar = document.querySelector('.sidebar')
			const overlay = document.getElementById('overlay')

			overlay.classList.remove('hidden')
			menubar.style.display ='block'
		})
	}
	const closeMenuButton = document.querySelector('.close-menu-button')
	if (closeMenuButton) {
		closeMenuButton.addEventListener('click', (ev) => {
			const menubar = document.querySelector('.sidebar')
			const overlay = document.getElementById('overlay')

			overlay.classList.add('hidden')
			menubar.style.display ='none'
		})
	}
}

export const initDraggableElements = () => {
// Select all draggable elements
	document.querySelectorAll('.draggable').forEach((draggable) => {
		const dragHandle = draggable.querySelector('.drag-handle')
		let active = false
		let currentX
		let currentY
		let initialX
		let initialY
		let xOffset = 0
		let yOffset = 0

		const dragStart = (e) => {
			initialX = e.clientX - xOffset
			initialY = e.clientY - yOffset

			if (e.target === dragHandle) {
				active = true
			}
		}

		const drag = (e) => {
			if (active) {
				e.preventDefault()

				currentX = e.clientX - initialX
				currentY = e.clientY - initialY
				xOffset = currentX
				yOffset = currentY

				setTranslate(currentX, currentY, draggable)
			}
		}

		const dragEnd = () => {
			initialX = currentX
			initialY = currentY
			active = false
		}

		const setTranslate = (xPos, yPos, el) => {
			el.style.transform = `translate3d(${xPos}px, ${yPos}px, 0)`
		}

		dragHandle.addEventListener('mousedown', dragStart, false)
		document.addEventListener('mouseup', dragEnd, false)
		document.addEventListener('mousemove', drag, false)
	})
}
